var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h2", { attrs: { tabindex: "-1" } }, [
      _vm._v("\n    " + _vm._s(_vm.$t("SummaryReport.Results.Title")) + "\n  ")
    ]),
    _vm._v(" "),
    _vm.results
      ? _c(
          "div",
          [
            _c("text-area-row", {
              attrs: {
                title: "SummaryReport.Results.ProductivenessDescription",
                id: "productivenessdescription",
                required: true,
                maxLength: 1500,
                rows: 10
              },
              model: {
                value: _vm.results.productivenessDescription,
                callback: function($$v) {
                  _vm.$set(_vm.results, "productivenessDescription", $$v)
                },
                expression: "results.productivenessDescription"
              }
            }),
            _vm._v(" "),
            _c(
              "h3",
              { staticClass: "mb-3" },
              [
                _c("plain-text-control", {
                  attrs: { title: "SummaryReport.Results.MeasuredTargetsTitle" }
                })
              ],
              1
            ),
            _vm._v(" "),
            _vm._l(_vm.results.measuredTargets, function(
              measuredTarget,
              index
            ) {
              return _c(
                "div",
                {
                  key: "measured-target-" + index,
                  staticClass: "group-wrapper mb-3"
                },
                [
                  _c(
                    "div",
                    { class: "heading-div" },
                    [
                      _c("header-control", {
                        attrs: {
                          title: _vm.getMeasuredTargetTitle(index),
                          h4: true,
                          doNotUseResources: true
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("measured-target-control", {
                    key: _vm.meterKey + index,
                    attrs: {
                      measuredTarget: measuredTarget,
                      targetIndex: index
                    }
                  })
                ],
                1
              )
            }),
            _vm._v(" "),
            _c("text-area-row", {
              attrs: {
                title: "SummaryReport.Results.PositiveFactors",
                id: "positivefactors",
                required: true,
                maxLength: 1000,
                rows: 12
              },
              model: {
                value: _vm.results.positiveFactors,
                callback: function($$v) {
                  _vm.$set(_vm.results, "positiveFactors", $$v)
                },
                expression: "results.positiveFactors"
              }
            }),
            _vm._v(" "),
            _c("text-area-row", {
              attrs: {
                title: "SummaryReport.Results.NegativeFactors",
                id: "negativefactors",
                required: true,
                maxLength: 1000,
                rows: 12
              },
              model: {
                value: _vm.results.negativeFactors,
                callback: function($$v) {
                  _vm.$set(_vm.results, "negativeFactors", $$v)
                },
                expression: "results.negativeFactors"
              }
            }),
            _vm._v(" "),
            _c("text-area-row", {
              attrs: {
                title: "SummaryReport.Results.TargetResultComparison",
                id: "targetresultcomparison",
                required: true,
                maxLength: 4000,
                rows: 12
              },
              model: {
                value: _vm.results.targetResultComparison,
                callback: function($$v) {
                  _vm.$set(_vm.results, "targetResultComparison", $$v)
                },
                expression: "results.targetResultComparison"
              }
            })
          ],
          2
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }